import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchRoutineDetail,
  selectRoutines,
  selectLoading
} from '../../features/adminSlice';

const AdminRoutineList = () => {
  const dispatch = useDispatch();
  const routines = useSelector(selectRoutines);
  const loading = useSelector(selectLoading);

  const handleEdit = (oid) => {
    dispatch(fetchRoutineDetail(oid));
  };

  return (
    <div className="bg-[#111827] rounded-lg border border-gray-800 overflow-auto">
      <div className="px-6 py-4 border-b border-gray-800 flex items-center gap-3">
        <h2 className="text-lg font-semibold">Stored Routines</h2>
        <span className="text-sm text-gray-400">
          ({routines.length} routine{routines.length !== 1 ? 's' : ''})
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-[#1F2937]">
            <tr>
              {['Name', 'Type', 'Language', 'Arguments'].map((h) => (
                <th key={h} className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                  {h}
                </th>
              ))}
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-400 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800">
            {routines.length === 0 ? (
              <tr>
                <td colSpan={5} className="px-4 py-8 text-center text-gray-500">
                  No routines found.
                </td>
              </tr>
            ) : (
              routines.map((r) => (
                <tr key={r.oid} className="hover:bg-[#1F2937]/50 transition-colors">
                  <td className="px-4 py-3 text-sm font-mono text-gray-300">{r.routine_name}</td>
                  <td className="px-4 py-3 text-sm">
                    <span className={`px-2 py-1 rounded text-xs font-medium ${
                      r.routine_type === 'FUNCTION'
                        ? 'bg-blue-900/50 text-blue-300'
                        : 'bg-purple-900/50 text-purple-300'
                    }`}>
                      {r.routine_type}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-400">{r.language}</td>
                  <td className="px-4 py-3 text-sm text-gray-400 font-mono max-w-sm truncate" title={r.arguments}>
                    {r.arguments || <span className="text-gray-600 italic">none</span>}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <button
                      onClick={() => handleEdit(r.oid)}
                      disabled={loading}
                      className="p-2 text-gray-400 hover:text-[#44C2FD] hover:bg-gray-800 rounded transition-colors disabled:opacity-50"
                      title="Edit definition"
                    >
                      <span className="material-icons text-sm">edit</span>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminRoutineList;
